import { Card, SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const ConnectionApplicationSkeleton: FC = () => {
  return (
    <div className="my-4 space-y-4">
      <Card>
        <Card.Body className="space-y-4">
          <SkeletonLoader.Title className="w-1/6" />
        </Card.Body>
      </Card>

      <Card>
        <Card.Body className="space-y-4">
          <SkeletonLoader.Title className="w-1/6" />
          <SkeletonLoader.Text className="w-1/2" />

          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
        </Card.Body>
      </Card>

      <Card>
        <Card.Body className="space-y-4">
          <SkeletonLoader.Title className="w-1/6" />
          <SkeletonLoader.Text className="w-1/2" />

          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
        </Card.Body>
      </Card>

      <Card>
        <Card.Body className="space-y-4">
          <SkeletonLoader.Title className="w-1/6" />
          <SkeletonLoader.Text className="w-1/2" />

          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
        </Card.Body>
      </Card>
    </div>
  );
};

export default ConnectionApplicationSkeleton;
